import React from 'react';
import { User, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * Pre-chat form — collects name + email before starting a conversation.
 */
const CustomerInfo = ({ userInfo, onChange, onSubmit, isLoading }) => {
  return (
    <div className="flex-1 p-6 flex flex-col justify-center">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <User className="h-8 w-8 text-green-600" />
        </div>
        <h4 className="font-semibold text-lg">Start a Conversation</h4>
        <p className="text-sm text-gray-500">We're here to help!</p>
      </div>
      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          placeholder="Your Name"
          value={userInfo.name}
          onChange={(e) => onChange({ ...userInfo, name: e.target.value })}
          required
          data-testid="chat-name-input"
        />
        <Input
          type="email"
          placeholder="Your Email"
          value={userInfo.email}
          onChange={(e) => onChange({ ...userInfo, email: e.target.value })}
          required
          data-testid="chat-email-input"
        />
        <Button type="submit" className="w-full bg-green-600 hover:bg-green-700" disabled={isLoading} data-testid="chat-start-btn">
          {isLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
          Start Chat
        </Button>
      </form>
    </div>
  );
};

export default CustomerInfo;
